<ng-template #leaderboardCoreError>
  <h2 class="contest-error">
    Erreur dans la requête, veuillez vérifier l'URL et recharger la page.
  </h2>
</ng-template>

<ng-template #leaderboardEmptyState>
  <h2 class="contest-error">Soyez le premier à terminer une activité</h2>
</ng-template>

<ng-template
  #titleBlock
  let-visibility="visibility"
  let-className="className"
  let-side="side"
  let-text="text">
  <div
    [style.visibility]="visibility"
    [class]="getTitleBlockClasses(className, side)"
    [attr.role]="isMobileViewport() ? 'button' : null"
    [attr.aria-pressed]="isMobileViewport() ? selectedLeaderboardOnMobile() === side : null"
    [attr.tabindex]="isMobileViewport() ? 0 : null"
    (keydown.enter)="selectLeaderboardOnMobile(side)"
    (keydown.space)="$event.preventDefault(); selectLeaderboardOnMobile(side)"
    (click)="selectLeaderboardOnMobile(side)">
    <p>{{ text }}</p>
  </div>
</ng-template>

@defer (when contestService.isReady()) {
  @let hasRankingError = contestService.rankingLeaderboard.error() !== null;
  @let hasHistoryError = contestService.historyLeaderboard.error() !== null;
  @let isRankingLoading = contestService.rankingLeaderboard.isLoading();
  @let isHistoryLoading = contestService.historyLeaderboard.isLoading();
  @let rankingUsers = contestService.rankingLeaderboard.participants();

  <div
    [class.is-leaving]="isLoaderLeaving"
    (transitionend)="onLoaderTransitionEnd($event)"
    [style.display]="disableLoading ? 'none' : 'block'"
    class="loader-page">
    <div class="loader-con">
      <kin-pulse-loader />
    </div>
  </div>

  @if (!isFullscreen() && store.userInfo(); as userInfo) {
    <app-contest-header
      [video]="videoInformation"
      [name]="userInfo.full_name"
      [profileImg]="userInfo.avatar_url"
      [theme]="store.template().theme"
      [headerConfig]="store.template().header" />
  }

  <div
    [style]="{
      '--has-two-table': isMobileViewport() ? 1 : +store.template().hasTwoTables + 1,
    }"
    [class.is-fullscreen]="isFullscreen()"
    [class.mobile-show-left]="selectedLeaderboardOnMobile() === 'left'"
    [class.mobile-show-right]="selectedLeaderboardOnMobile() === 'right'"
    class="main-con">
    <!-- Leaderboard core defer -->

    @if (rankingUsers.length > 0 || isRankingLoading || isHistoryLoading) {
      @if (!isFullscreen()) {
        <div
          class="leaderboard-titles-container"
          [class.is-dragging]="divider()?.isDragging ?? false">
          <ng-container
            *ngTemplateOutlet="
              titleBlock;
              context: {
                visibility: (divider()?.isLeftPartShrink ?? false) ? 'hidden' : 'visible',
                className: 'leaderboard-title-left',
                side: 'left',
                text: 'Classement',
              }
            " />
          @if (store.template().hasTwoTables) {
            <ng-container
              *ngTemplateOutlet="
                titleBlock;
                context: {
                  visibility: (divider()?.isRightPartShrink ?? false) ? 'hidden' : 'visible',
                  className: 'leaderboard-title-right',
                  side: 'right',
                  text: 'Historique',
                }
              " />
          }
        </div>
      }

      <div class="leaderboards-con">
        <div
          class="leaderboard-con left-leaderboard-container"
          [class.mobile-hidden]="!isLeaderboardVisible('left')"
          #leaderboardLeftContainer>
          <app-contest-leaderboard-panel
            kind="ranking"
            [class.is-dragging]="divider()?.isDragging ?? false"
            [class.is-shrunk]="divider()?.isLeftPartShrink ?? false"
            [editionModeEnabled]="editionModeEnabled()"
            [showRankingBlock]="showRankingBlock()" />
        </div>

        @if (store.template().hasTwoTables) {
          <app-divider
            #divider
            class="divider"
            [class]="{
              'margin-left-null': divider.isLeftPartShrink,
              'margin-right-null': divider.isRightPartShrink,
            }"
            [color]="store.template().theme.secondaryColor"
            [leftPart]="leaderboardLeftContainer"
            [rightPart]="leaderboardRightContainer"
            [shrinkSize]="420" />

          <div
            class="leaderboard-con right-leaderboard-container"
            [class.mobile-hidden]="!isLeaderboardVisible('right')"
            #leaderboardRightContainer>
            <app-contest-leaderboard-panel
              kind="history"
              [class.is-dragging]="divider.isDragging"
              [class.is-shrunk]="divider.isRightPartShrink"
              [editionModeEnabled]="editionModeEnabled()" />
          </div>
        }
      </div>
    } @else if (hasRankingError || hasHistoryError) {
      <ng-container *ngTemplateOutlet="leaderboardCoreError" />
    } @else if (rankingUsers.length === 0) {
      <ng-container *ngTemplateOutlet="leaderboardEmptyState" />
    }
  </div>
} @placeholder {
  <div class="loader-page">
    <div class="loader-con">
      <kin-pulse-loader />
    </div>
  </div>
} @error {
  <ng-container *ngTemplateOutlet="leaderboardCoreError" />
}

@if (contestService.isReady()) {
  <kin-icon-btn
    class="fullscreen-btn"
    [style.--fullscreen-button-color]="store.template().theme.secondaryColor"
    [class.is-fullscreen]="isFullscreen()"
    (onClick)="toggleFullscreen()"
    [fill]="false"
    icon="full_screen"
    [color]="store.templateControlColor()"
    size="small" />
}

@if (contestService.isReady()) {
  <app-toolbar-dock [iconColor]="store.secondaryControlColor()" [isHidden]="isFullscreen()">
    <app-toolbar-contest
      class="toolbar"
      [(showRankingBlock)]="showRankingBlock"
      [(editionModeEnabled)]="editionModeEnabled" />
  </app-toolbar-dock>
}
